import {
  ADMIN_MANUAL_EMAIL_APPROVAL,
  ADMIN_MANUAL_EMAIL_APPROVAL_ERROR,
  ADMIN_MANUAL_EMAIL_APPROVAL_SUCCESS,
} from "../modules/accountAdmin/actions/accountAdminActions";
import AuthFetch from "../auth/AuthFetch";
import type { Middleware } from "@reduxjs/toolkit";

const apiEndpoint = `${import.meta.env.API_ENDPOINT}/api/AccountAdmin`;

const accountAdminApi: Middleware = (store) => (next) => (action) => {
  next(action);
  switch (action.type) {
    case ADMIN_MANUAL_EMAIL_APPROVAL: {
      AuthFetch(fetch, `${apiEndpoint}/setManualEmailRequired`, {
        method: "POST",
        body: JSON.stringify(action.payload.data.manualEmailApproval),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.responseStatus !== 1) {
            return next({
              type: ADMIN_MANUAL_EMAIL_APPROVAL_ERROR,
              payload: {
                data: data.errorMessage,
              },
            });
          }
          return next({
            type: ADMIN_MANUAL_EMAIL_APPROVAL_SUCCESS,
            payload: {
              data: data.accounts,
            },
          });
        })
        .catch((err) => {
          return next({
            type: ADMIN_MANUAL_EMAIL_APPROVAL_ERROR,
            payload: {
              data: err,
            },
          });
        });
      break;
    }

    default:
      return store;
  }
};

export default accountAdminApi;
